<template>
  <div style="height: 100%;width: 1200px;margin: auto">
<!--<iframe name="myiframe" id="myrame" src="https://www.sme.com.cn/cms/show.action?code=jumpchanneltemplate&siteid=100000&channelid=0000000817" frameborder="0" align="left" width="1200px"  style="min-height: 570px; height: auto;" height="100%"  scrolling="no" marginWidth=0 marginHeight=0 class="iframesty">-->
<!--   <p class="tip">你的浏览器不支持iframe标签</p>-->
<!--</iframe>-->
  <div class="app-container">
    <div style="min-height:600px; width: 1000px;margin: auto">
                <div v-for="(item,index) in list" :key="index" style="line-height: 40px" :index="item.path">
              <router-link :to="{path:'/news', query: { id: item.id }}" target="_blank">
                <div class="listNews">{{ item.title }}</div>
                <div style="float: right;font-size: 16px;color: #444444">{{ item.publishDate.substring(0, 10) }}</div>
              </router-link>
            </div>
      </div>
<!--    <el-table-->
<!--      v-loading="listLoading"-->
<!--      :data="list"-->
<!--      element-loading-text="Loading"-->
<!--      border-->
<!--      fit-->
<!--      highlight-current-row-->
<!--    >-->

<!--      <el-table-column label="标题" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ scope.row.title }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="发布时间" width="150" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ scope.row.publishDate.substring(0, 10) }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--    </el-table>-->
    <Pagination
      :current-page="currentPage"
      :total="total"
      :limit="limit"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />
  </div>
  </div>
</template>

<script>
import { list } from '@/api/news'
import Pagination from '@/components/Pagination'
export default {
  name: 'Home',
  components: {
    Pagination
  },
  data () {
    return {
      channel: [],
      list: null,
      listLoading: true,
      index: '',
      sortIndex: 0,
      carouselIndex: 0,
      currentPage: 1,
      limit: 15,
      total: 0
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      list({ currentPage: this.currentPage, channelId: '1', pagenow: this.currentPage }).then(response => {
        if (response.result === 1) {
          this.total = response.data.total
          this.list = response.data.list
        } this.listLoading = false
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleSizeChange (val) {
      this.limit = val
      this.currentPage = 1
      this.fetchData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
    .listNews{
    height: 40px;
    width: 450px;
    float: left;
    font-size: 16px;
    line-height: 40px;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #444444;
  }
</style>



// WEBPACK FOOTER //
// src/components/computer/sxcj.vue